export const categoryOptions = [
  { value: "vente", label: "Vente" },
  { value: "location", label: "Location" },
];

export const defaultCategoryOption = [{ value: "vente", label: "Vente" }];
